import React from 'react';
import { useField, useFormState } from 'react-final-form';
import { SxProps, Theme } from '@mui/material';
import DateTextField from './DateTextField';

interface FormDateTextFieldProps {
  fieldName: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

const FormDateTextField: React.FC<FormDateTextFieldProps> = ({ fieldName, disabled, sx }) => {
  const { input, meta } = useField<string | null>(fieldName);
  const { submitFailed } = useFormState({ subscription: { submitFailed: true } });
  const isRequiredError = meta.error === 'Required';
  const showError = isRequiredError ? submitFailed : meta.touched || submitFailed;

  return (
    <DateTextField
      value={input.value}
      onChange={input.onChange}
      onBlur={input.onBlur}
      disabled={disabled}
      sx={sx}
      error={showError ? meta.error : undefined}
    />
  );
};

export default FormDateTextField;
